import {Action} from 'redux';
import { RatesRequestTestParameters } from '../../../api/pricing/pricing.types';

export const UPDATE_RATES_REQUEST_TEST_FILTERS = 'UPDATE_RATES_REQUEST_TEST_FILTERS';

export interface RatesRequestTestState {
    filters:  RatesRequestTestParameters | null;
}

export interface UpdateRatesRequestTestFiltersAction extends Action {
    type: typeof UPDATE_RATES_REQUEST_TEST_FILTERS;
    payload: {
        filters: RatesRequestTestParameters;
    };
}

export type RatesRequestTestActionTypes = UpdateRatesRequestTestFiltersAction;
